export default __webpack_public_path__ + "static/paidy-06bd871c6441f283df43669d1ee30e8e.png";